/* eslint-disable react/no-danger */
import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { FaCircleCheck, FaCircleExclamation, FaCircleInfo, FaTriangleExclamation } from 'react-icons/fa6';

const TYPE_CONFIG = {
  danger: {
    title: 'Erro',
    icon: FaCircleExclamation,
    accentClass: 'toast-danger',
    iconColor: '#ef4444',
    bgColor: '#fef2f2',
  },
  warning: {
    title: 'Alerta',
    icon: FaTriangleExclamation,
    accentClass: 'toast-warning',
    iconColor: '#f59e0b',
    bgColor: '#fffbeb',
  },
  success: {
    title: 'Sucesso',
    icon: FaCircleCheck,
    accentClass: 'toast-success',
    iconColor: '#10b981',
    bgColor: '#ecfdf5',
  },
  info: {
    title: 'Informação',
    icon: FaCircleInfo,
    accentClass: 'toast-info',
    iconColor: '#3b82f6',
    bgColor: '#eff6ff',
  },
};

export default function Toasts({ items, clear }) {
  return items?.length > 0 && (
    <ToastContainer containerPosition="fixed" position="top-end" className="messages-toast-container">
      {items.filter((el) => el.toast).map((item) => {
        const config = TYPE_CONFIG[item.type] || TYPE_CONFIG.info;
        const IconComponent = config.icon;

        return (
          <Toast
            onClose={() => clear(item.id)}
            autohide
            delay={10000}
            key={item.id}
            className={`custom-toast ${config.accentClass}`}
          >
            <Toast.Header className="custom-toast-header">
              <div className="toast-icon-badge me-2" style={{ backgroundColor: config.bgColor, color: config.iconColor }}>
                <IconComponent size={16} />
              </div>
              <strong className="me-auto toast-title">{item.title ?? config.title}</strong>
            </Toast.Header>
            <Toast.Body className="custom-toast-body">
              <span dangerouslySetInnerHTML={{ __html: item.message }} />
            </Toast.Body>
          </Toast>
        );
      })}
    </ToastContainer>
  );
}

